import manifest from '../../tools/manifest/voice-lines.json';

export interface AnnouncerVariant {
  text: string;
  caption: string;
  /** Director notes for Eleven v3. Not spoken at runtime. */
  direction?: string;
}

export interface AnnouncerGroup {
  id: string;
  /** Higher jumps the queue. 1 = idle chatter, 6 = death call. */
  priority: number;
  /** Seconds before the same group may play again (0 = no limit). */
  cooldown: number;
  variants: AnnouncerVariant[];
}

/** A concrete clip: group metadata plus the chosen variant. Clip file is `<groupId>_<index>.mp3`. */
export interface AnnouncerLine {
  id: string;
  groupId: string;
  priority: number;
  text: string;
  caption: string;
}

interface VoiceManifest {
  voice: string;
  fallbackVoice: string;
  style?: number;
  groups: AnnouncerGroup[];
}

const data = manifest as VoiceManifest;

export const ANNOUNCER_GROUPS: ReadonlyMap<string, AnnouncerGroup> = new Map(data.groups.map((g) => [g.id, g]));

export function clipId(groupId: string, index: number): string {
  return `${groupId}_${index}`;
}

export function announcerGroup(id: string): AnnouncerGroup | undefined {
  return ANNOUNCER_GROUPS.get(id);
}

export function announcerLine(groupId: string, index: number): AnnouncerLine | undefined {
  const g = ANNOUNCER_GROUPS.get(groupId);
  const v = g?.variants[index];
  if (!g || !v) return undefined;
  return { id: clipId(groupId, index), groupId, priority: g.priority, text: v.text, caption: v.caption };
}

/** Every clip id in the manifest, for preloading. */
export function allClipIds(): string[] {
  const out: string[] = [];
  for (const g of data.groups) for (let i = 0; i < g.variants.length; i++) out.push(clipId(g.id, i));
  return out;
}
